import { IIndemnity, IVehicule } from "../../interfaces";

const amountCalculator = (
  distance: number,
  prevDistance: number,
  rules: { coeff: number; addj: number }[],
  ranges: number[]
) => {
  let amount = 0;
  if (distance <= ranges[0]) {
    amount = Math.abs(distance - prevDistance) * rules[0].coeff + rules[0].addj;
  }
  if (distance >= ranges[0] && distance < ranges[1]) {
    if (prevDistance < ranges[0]) {
      amount =
        Math.abs(distance - ranges[0]) * rules[1].coeff +
        rules[1].addj +
        Math.abs(ranges[0] - prevDistance) * rules[0].coeff +
        rules[0].addj;
    } else {
      amount =
        Math.abs(distance - prevDistance) * rules[1].coeff;
    }
  }
  if (distance >= ranges[1]) {
    if (prevDistance < ranges[0]) {
      amount =
        Math.abs(distance - ranges[1]) * rules[2].coeff +
        rules[2].addj +
        Math.abs(ranges[1] - ranges[0]) * rules[1].coeff +
        rules[1].addj +
        Math.abs(ranges[0] - prevDistance) * rules[0].coeff +
        rules[0].addj;
    } else {
      amount =
        Math.abs(distance - ranges[1]) * rules[2].coeff +
        rules[2].addj +
        Math.abs(ranges[1] - prevDistance) * rules[1].coeff;
    }
  }
  return amount;
};

const amountFinder = (
  distance: number,
  vehicule: IVehicule,
  prevDistance: number
) => {
  let amount = 0;

  switch (vehicule.type) {
    case "car":
      if (vehicule.hp! <= 3) {
        amount = amountCalculator(
          distance,
          prevDistance,
          [
            { coeff: 0.529, addj: 0 },
            { coeff: 0.316, addj: 1065 },
            { coeff: 0.370, addj: 0 },
          ],
          [5000, 20000]
        );
      }
      if (vehicule.hp === 4) {
        amount = amountCalculator(
          distance,
          prevDistance,
          [
            { coeff: 0.606, addj: 0 },
            { coeff: 0.340, addj: 1330 },
            { coeff: 0.407, addj: 0 },
          ],
          [5000, 20000]
        );
      }
      if (vehicule.hp === 5) {
        amount = amountCalculator(
          distance,
          prevDistance,
          [
            { coeff: 0.636, addj: 0 },
            { coeff: 0.357, addj: 1395 },
            { coeff: 0.427, addj: 0 },
          ],
          [5000, 20000]
        );
      }
      if (vehicule.hp === 6) {
        amount = amountCalculator(
          distance,
          prevDistance,
          [
            { coeff: 0.665, addj: 0 },
            { coeff: 0.374, addj: 1457 },
            { coeff: 0.447, addj: 0 },
          ],
          [5000, 20000]
        );
      }
      if (vehicule.hp! >= 7) {
        amount = amountCalculator(
          distance,
          prevDistance,
          [
            { coeff: 0.697, addj: 0 },
            { coeff: 0.394, addj: 1515 },
            { coeff: 0.470, addj: 0 },
          ],
          [5000, 20000]
        );
      }
      break;

    case "motorcycle":
      if (vehicule.hp! <= 2 && vehicule.hp! >= 1) {
        amount = amountCalculator(
          distance,
          prevDistance,
          [
            { coeff: 0.395, addj: 0 },
            { coeff: 0.099, addj: 891 },
            { coeff: 0.248, addj: 0 },
          ],
          [3000, 6000]
        );
      }
      if ([3, 4, 5].includes(vehicule.hp!)) {
        amount = amountCalculator(
          distance,
          prevDistance,
          [
            { coeff: 0.468, addj: 0 },
            { coeff: 0.082, addj: 1158 },
            { coeff: 0.275, addj: 0 },
          ],
          [3000, 6000]
        );
      }
      if (vehicule.hp! >= 5) {
        amount = amountCalculator(
          distance,
          prevDistance,
          [
            { coeff: 0.606, addj: 0 },
            { coeff: 0.079, addj: 1158 },
            { coeff: 0.343, addj: 0 },
          ],
          [3000, 6000]
        );
      }
      break;

    case "moped":
      amount = amountCalculator(
        distance,
        prevDistance,
        [
          { coeff: 0.315, addj: 0 },
          { coeff: 0.079, addj: 711 },
          { coeff: 0.198, addj: 0 },
        ],
        [3000, 6000]
      );
      break;

    default:
      break;
  }

  return amount;
};

const useIndemnity = () => {
  const calculateAmount = (
    vehicule: IVehicule,
    prevIndemnities: IIndemnity[],
    distance: number
  ) => {
    let totDistance =
      distance +
      prevIndemnities.reduce((acc, curr) => acc + (curr.kms || 0), 0);

    const amount = amountFinder(
      totDistance,
      vehicule,
      prevIndemnities.reduce((acc, curr) => acc + (curr.kms || 0), 0)
    );

    return amount;
  };

  return {
    calculateAmount,
  };
};

export { useIndemnity };
